export default "__VITE_ASSET__fBB$1e6v__"